import { render, staticRenderFns } from "./createInfoDialog.vue?vue&type=template&id=3aea86c2&scoped=true"
import script from "./createInfoDialog.vue?vue&type=script&lang=js"
export * from "./createInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./createInfoDialog.vue?vue&type=style&index=0&id=3aea86c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aea86c2",
  null
  
)

export default component.exports